import { combineEpics } from 'redux-observable';
import estimationUpdate from './estimationDraftUpdate';
import estimationsDraftGet from './estimationsDraftGet';
import estimationsPlace from './estimationsPlace';
import estimationDetailsGet from './estimationDetailsGet';
import estimationsGetAll from './estimationsGetAll';
import estimationsImport from './estimationsImport';

export default combineEpics(
    estimationUpdate,
    estimationsDraftGet,
    estimationsPlace,
    estimationDetailsGet,
    estimationsGetAll,
    estimationsImport
);



// WEBPACK FOOTER //
// ./src/application/estimations/epic/index.ts